// MessageRenderer.js
import React from 'react';
import TextMessage from './TextMessage';
import ImageMessage from './ImageMessage';
import AgentQuestionMessage from './AgentQuestionMessage';
import DocumentMessage from './DocumentMessage';
import InteractiveMessage from './InteractiveMessage';
import VideoMessage from './VideoMessage';

const choices = ["I'm new to Callbell", 'Give me info', 'I already know Callbell'];

const MessageRenderer = ({
  message,
  handleButtonReplyClick,
  selectedColor,
  textColor
}) => {
  const onButtonReplyClick = (buttonTitle) => {
    handleButtonReplyClick(buttonTitle);
  };

  const renderMessage = () => {
    switch (message?.type) {
      case 'text':
        return (
          <TextMessage
            text={message.content}
            time={message.time}
            senderType={message.senderType}
            selectedColor={selectedColor}
            textColor={textColor}
          />
        );
      case 'image':
        return (
          <ImageMessage
            src={message.attachment}
            caption={message.content}
            time={message.time}
            senderType={message.senderType}
            selectedColor={selectedColor}
          />
        );
      case 'document':
        return (
          <DocumentMessage
            src={message.attachment}
            caption={message.content}
            time={message.time}
            senderType={message.senderType}
            selectedColor={selectedColor}
          />
        );
      case 'interactive':
        return (
          <InteractiveMessage
            text={message.content}
            options={message.options}
            src={message.attachment}
            time={message.time}
            onButtonReplyClick={(buttonTitle) => onButtonReplyClick(buttonTitle)}
          />
        );
      case 'question':
        return (
          <AgentQuestionMessage
            src="Please choose between the following Choices"
            time={message.time}
            questionsCount="3"
            choices={choices}
          />
        );
      case 'video':
        return (
          <VideoMessage
            src={message.attachment}
            time={message.time}
            senderType={message.senderType}
            caption={message.content}
            selectedColor={selectedColor}
          />
        );
      default:
        return <p>Unsupported message type</p>;
    }
  };

  return renderMessage();
};

export default MessageRenderer;
